// className combiner — joins truthy parts AND resolves Tailwind conflicts so
// the LAST class wins (e.g. a caller's `bg-facebook text-white` overrides a
// component variant's `bg-white text-ink-2`). Plain string-joining left both
// in place and CSS source order decided, which produced white-on-white buttons.
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // Custom tokens from tailwind.config so they merge like built-ins.
      rounded: [{ rounded: ['card', 'button'] }],
      shadow: [{ shadow: ['card'] }],
    },
  },
});

export function cn(...parts: Array<string | false | null | undefined>): string {
  return twMerge(parts.filter(Boolean).join(' '));
}
